import { HttpErrorResponse } from '@angular/common/http';
import { Action, createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { GetOrganizationChecklistDto } from '../../../../../../../../aumico-lib-users-fe/src/public-api';
import { FileMetadataDto } from '../../dto/file-metadata.dto';
import { FcpDataDTO } from '../helpers/export.helper';
import { ClosingEntry, Comment, DocumentLink, Task } from '../models/fcp.model';
import { FcpTreeItem } from '../models/fcpTreeItem.model';
export const setActiveNavigation = createAction('[Aumico-FCP] setActiveNavigation', props<{ payload: FcpTreeItem }>());
export const setActiveNavigationSuccess = createAction(
    '[Aumico-FCP] setActiveNavigation Success',
    props<{ payload: FcpTreeItem }>(),
);
export const setNavigationItems = createAction('[Aumico-FCP] setNavigationItems', props<{ payload: FcpTreeItem[] }>());
export const setNavigationItemsSuccess = createAction(
    '[Aumico-FCP] setNavigationItems Success',
    props<{ payload: FcpTreeItem[] }>(),
);
export const setRootItem = createAction('[Aumico-FCP] setRootItem', props<{ payload: FcpTreeItem }>());

export const resetActiveItems = createAction('[Aumico-FCP] reset items');

export const toggleActiveTestGroupItem = createAction(
    '[Aumico-FCP] toggleActiveTestGroupItem',
    props<{ payload: FcpTreeItem }>(),
);
export const toggleActiveTestGroupItemSuccess = createAction(
    '[Aumico-FCP] toggleActiveTestGroupItemSuccess Success',
    props<{ payload: FcpTreeItem }>(),
);
export const unsetActiveTestItem = createAction('[Aumico-FCP] unsetActiveTestItem');
export const toggleActiveTestItem = createAction(
    '[Aumico-FCP] toggleActiveTestItem',
    props<{ payload: FcpTreeItem }>(),
);
export const setActiveTestItemSuccess = createAction(
    '[Aumico-FCP] toggleActiveTestItemSuccess Success',
    props<{ payload: FcpTreeItem }>(),
);
export const setFcpItemToReset = createAction('[Aumico-FCP] setItemToReset', props<{ payload: FcpTreeItem }>());
export const setShowAdjustments = createAction('[Aumico-FCP] setShowAdjustments', props<{ payload: boolean }>());

export const addComment = createAction('[Aumico-FCP] Add Comment', props<{ payload: Comment }>());
export const updateComment = createAction('[Aumico-FCP] Update Comment', props<{ payload: Comment }>());
export const deleteComment = createAction('[Aumico-FCP] Delete Comment', props<{ payload: Comment }>());

export const addClosingEntry = createAction('[Aumico-FCP] Add ClosingEntry', props<{ payload: ClosingEntry }>());
export const updateClosingEntry = createAction('[Aumico-FCP] Update ClosingEntry', props<{ payload: ClosingEntry }>());
export const deleteClosingEntry = createAction('[Aumico-FCP] Delete ClosingEntry', props<{ payload: ClosingEntry }>());

export const updateChecklist = createAction(
    '[Aumico-FCP] Update Checklist For Test Item',
    props<{ tasks: Task[]; checklistName: string }>(),
);

export const createChecklistForTestGroup = createAction(
    '[Aumico-FCP] Create Checklist For Test Group',
    props<{ tasks: Task[]; checklistName: string }>(),
);

export const updateTasksForTestGroupAndItsChildren = createAction(
    '[Aumico-FCP] Update Task For Test Group And Its Children',
    props<{ updatedTasks: Task[]; createdTasks: Task[]; deletedTasks: string[] }>(),
);

export const markAllTasksAsCompleted = createAction(
    '[Aumico-FCP] Mark All Tasks As Completed',
    props<{ doneBy: string; doneByName: string; task: string }>(),
);

export const deleteChecklist = createAction('[Aumico-FCP] Delete Checklist');

export const financialClosingProcessItemDocument = createActionGroup({
    source: '[Aumico-Users] Upload Financial Closing Process Item Document',
    events: {
        do: props<{
            file: FormData;
            fileMetaData: Pick<DocumentLink, 'name' | 'dueDate' | 'uploadedByName'>;
        }>(),
        success: props<{ payload: Partial<FileMetadataDto> }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
        download: props<{ documentName?: string; documentId: string }>(),
        downloadSuccess: emptyProps(),
        updateInActiveItem: props<{ payload: string }>(),
        markForDeletionFcpDocuments: props<{ payload: string }>(),
        deleteFcpDocuments: props<{ payload: string[] }>(),
        deleteFcpDocumentSucces: emptyProps(),
        deleteFcpDocumentFailed: props<{ payload: HttpErrorResponse }>(),
    },
});

export const exportingFcpData = createActionGroup({
    source: '[Aumico-FCP]',
    events: {
        'Exporting Fcp Data': props<{
            payload: { data: FcpDataDTO; fileName: string };
        }>(),
        'Exporting Fcp Data Success': emptyProps(),
        'Exporting Fcp Data Failed': props<{ payload: HttpErrorResponse }>(),
    },
});

export const getFcpChecklist = createActionGroup({
    source: '[Aumico-FCP] Get fcp checklists for test item',
    events: {
        'Load Checklists': emptyProps(),
        'Load Checklists Success': props<{ checklists: GetOrganizationChecklistDto[] }>(),
        'Load Checklists Failure': props<{ error: HttpErrorResponse }>(),
    },
});

// Set Default
export const reset = createAction('[Aumico-FCP] reset');

export interface ActionWithPayload<T> extends Action {
    payload: T;
}
